import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
/**
 * Gets contextual information for ApplyConversationAction for a given conversation
 */
export default function getApplyConversationActionContext(conversationRowKey, tableViewId) {
    var tableConversationRelation = getTableConversationRelation(conversationRowKey, tableViewId);
    return {
        //TODO: use ClientItemId type in ApplyConversationActionContext: 23338
        // Work Item 27629: Remove workaround for timezone issue (sending requests in UTC time zone)
        conversationId: tableConversationRelation.id,
        conversationLastSyncTimeStamp: tableConversationRelation
            ? new Date(tableConversationRelation.lastModifiedTimeStamp).toISOString()
            : null,
    };
}
//# sourceMappingURL=getApplyConversationActionContext.js.map